// extracted by mini-css-extract-plugin
export default {"container":"HomePage_container__uNu-e","title":"HomePage_title__UFLA3","search":"HomePage_search__ssjgX","grid":"HomePage_grid__htsUs","card":"HomePage_card__glDvo"};